import { useContext } from 'react';
import notificationContext from '../contexts/notificationContext';

const useNotificationContext = () => {
  return useContext(notificationContext);
};

export default useNotificationContext;
